module.exports = __webpack_public_path__ + "img/0Q3B3332_P_T_L_BlackMatted_MockedUp.67dd169d.jpg";